// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/ordini-fornitori?societaId&stato',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","societaId":"number","sedeId":"number","fornitoreId":"number","stato":"BOZZA|EMESSO|CHIUSO|ANNULLATO","numero":"string|null","dataEmissione":"string|null","fornitoreRagioneSociale":"string|null","note":"string|null","createdAt":"string","fornitore":{"id":"number","ragioneSociale":"string"},"sede":{"id":"number","nome":"string"},"_count":{"righe":"number"},"ricezione":"NESSUNA|PARZIALE|COMPLETA"}]}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
